import { Priority } from "../../pages/reportFolio/pages/dashboard/typing";

export const priorityList = [
    {
        label: 'general.priority.suggestion',
        value: Priority.SUGGESTION,
        id: Priority.SUGGESTION,
    },
    {
        label: 'general.priority.medium',
        value: Priority.MEDIUM,
        id: Priority.MEDIUM,
    },
    {
        label: 'general.priority.urgent',
        value: Priority.URGENT,
        id: Priority.URGENT,
    },
]